/* ripple AIR "You can use it ..." carousel. Image, heading tail and pill label all switch
   together; each is a stack of absolutely/grid-stacked nodes so the change is a crossfade.
   The pill's width is driven from the active label so it grows and shrinks with the copy. */
(function () {
  'use strict';
  function qsa(el, s) { return [].slice.call(el.querySelectorAll(s)); }

  function Rua(root) {
    this.root = root;
    this.imgs = qsa(root, '[data-rua-img]');
    this.tails = qsa(root, '[data-rua-tail]');
    this.pills = qsa(root, '[data-rua-pill]');
    this.dots = qsa(root, '[data-rua-dot]');
    this.pw = root.querySelector('[data-rua-pw]');
    this.i = 0;
    this.timer = null;
    if (this.imgs.length) this.init();
  }

  Rua.prototype.show = function (i) {
    var n = this.imgs.length;
    this.i = ((i % n) + n) % n;
    var k = this.i;
    function mark(list) {
      list.forEach(function (el, j) { el.classList.toggle('is-on', j === k); });
    }
    mark(this.imgs); mark(this.tails); mark(this.pills); mark(this.dots);
    this.dots.forEach(function (d, j) { d.setAttribute('aria-current', j === k ? 'true' : 'false'); });
    this.tails.forEach(function (t, j) { t.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
    this.pills.forEach(function (p, j) { p.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
    this.sizePill();
  };

  Rua.prototype.sizePill = function () {
    if (!this.pw || !this.pills[this.i]) return;
    var w = this.pills[this.i].offsetWidth;
    if (w) this.pw.style.width = w + 'px';
  };

  Rua.prototype.start = function () {
    var self = this, ms = parseInt(this.root.getAttribute('data-rua-every'), 10);
    this.stop();
    if (!ms || this.imgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    this.timer = setInterval(function () { self.show(self.i + 1); }, ms);
  };
  Rua.prototype.stop = function () { if (this.timer) { clearInterval(this.timer); this.timer = null; } };
  /* any manual pick restarts the clock, so the slide you chose gets a full dwell */
  Rua.prototype.pick = function (i) { this.show(i); this.start(); };

  Rua.prototype.init = function () {
    var self = this, root = this.root;
    this.dots.forEach(function (d, j) {
      d.addEventListener('click', function () { self.pick(j); });
    });

    var card = root.querySelector('[data-rua-card]');
    if (card) {
      var x0 = null, y0 = null;
      card.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      card.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.pick(self.i + (dx < 0 ? 1 : -1));
      }, { passive: true });
      card.addEventListener('mouseenter', function () { self.stop(); });
      card.addEventListener('mouseleave', function () { self.start(); });
    }
    root.addEventListener('focusin', function () { self.stop(); });
    root.addEventListener('focusout', function () { self.start(); });

    /* labels are only measurable once their webfont has settled */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.sizePill(); });
    }
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(function () { self.sizePill(); }, 150);
    });

    this.show(0);
    this.start();
  };

  function boot() { qsa(document, '[data-rua]').forEach(function (r) { if (!r.__rua) r.__rua = new Rua(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
